import { Button, Form, Input, InputNumber, Rate, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { patchStudent, postStudent } from '~/services/student'
import { IStudent } from '~/types/student'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<IStudent>
  refreshTable: () => void
}> = (props) => {
  const { data, refreshTable } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<IStudent>>>['onFinish']
  >((value) => {
    setLoading(true)
    if (!data.id) {
      postStudent(value)
        .then(() => {
          message.success('操作成功')
          refreshTable()
        })
        .catch((err) => {
          message.error(err?.message || '操作失败，请稍后再试')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      patchStudent(data.id, value)
        .then(() => {
          message.success('操作成功')
          refreshTable()
        })
        .catch((err) => {
          message.error(err?.message || '操作失败，请稍后再试')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={data}
        onFinish={onFinish}
      >
        <Form.Item
          label="学生姓名"
          name="name"
          rules={[{ required: true, message: '请输入教师姓名' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="邮箱" name="email">
          <Input />
        </Form.Item>
        <Form.Item label="手机号码" name="phone">
          <Input />
        </Form.Item>
        <Form.Item label="年龄" name="age">
          <InputNumber />
        </Form.Item>
        <Form.Item label="头像" name="profileImgUrl">
          <Input />
        </Form.Item>
        <Form.Item label="代理ID" name="agentId">
          <InputNumber />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
